import React, { useState, useEffect } from 'react';
import highlightText from '../../../utils/functions/Highlight/highlight';

import { Input, Flex, Icon, Text } from '@mobilearch/react-ui';
import { Wrapper } from './styles';
interface SearchBarProps {
  disabled: boolean;
  closeSearchBar(): void;
}
const SearchBar = ({ disabled, closeSearchBar }: SearchBarProps): React.ReactElement => {
  const [foundElements, setFoundElements] = useState<Element[]>([]);
  const [elementPosition, setElementPosition] = useState<number>(0);
  const [searchInput, setSearchInput] = useState<string>('');

  useEffect(() => {
    if (foundElements.length > 0) {
      foundElements[elementPosition].scrollIntoView();
    }
  }, [foundElements, elementPosition]);

  useEffect(() => {
    highlightText(searchInput);
    setFoundElements(document.getElementsByClassName('highlight') as unknown as Element[]);
    setElementPosition(0);
  }, [searchInput]);

  return (
    <Wrapper>
      <Flex className="search-bar">
        <Flex className="search-input">
          <Input
            autoFocus
            disabled={disabled}
            value={searchInput}
            variant="standard"
            onChange={({ currentTarget }) => setSearchInput(currentTarget.value)}
          />
        </Flex>
        <Flex className="search-functions" alignItems="center">
          <Icon onClick={() => elementPosition > 0 && setElementPosition(elementPosition - 1)}>expand_less</Icon>
          <Text>{foundElements.length ? `${elementPosition + 1} of ${foundElements.length}` : '0 of 0'}</Text>
          <Icon
            onClick={() => !(elementPosition === foundElements.length - 1) && setElementPosition(elementPosition + 1)}
          >
            expand_more
          </Icon>
          <Icon
            onClick={() => {
              highlightText('');
              closeSearchBar();
            }}
          >
            close
          </Icon>
        </Flex>
      </Flex>
    </Wrapper>
  );
};

SearchBar.defaultProps = {
  disabled: false,
  closeSearchBar: () => {},
};

export default SearchBar;
